// 58171
// 64614
$(document).ready(function () {
    $(".btn-readmore-bio").click(function () {
        var bio = $(this).closest(".faculty-detail");
        if (bio.hasClass("collapsed")) {
            bio.removeClass("collapsed");
            $(this).text("Read Less...");
        } else {
            bio.addClass("collapsed");
            $(this).text("Read More...");
            $('html, body').animate({ scrollTop: $(bio).offset().top - 100 }, 'slow');
        }
    });
});
